module.exports = __webpack_public_path__ + "static/img/talentenspel_begeleiding_header.4280929.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/talentenspel_begeleiding_header.jpeg
// module id = 3kDF
// module chunks = 0